import useParams from '@/hooks/useParams';

export const clientRoutes = {
  Clients: () => '/clients',
  // TODO: @aryan02420 support slug
  ClientDetails: (clientId: string) => `/clients/${clientId}`,
};

export function useClientIdFromUrl() {
  const { clientId } = useParams<{ clientId: string }>();
  if (!clientId) {
    throw new Error('Tried to access clientId from URL, but it is not defined.');
  }
  return clientId;
}
